import React, { useEffect, useState } from "react";
import RadioButton from "@components/atoms/RadioButton";
import Spacer from "@components/atoms/Spacer";
import { SpaceType } from "@components/atoms/Spacer/types";
import styled from "styled-components/native";
import useScreenOptionsHooks from "../../../../hooks/useScreenOptionsHooks";
import { RadioSelectType } from "./types";
import { resetFormForInputs } from "../utils";
import { useTranslation } from "react-i18next";
import { DefaultTheme } from "styled-components/native";

const RadioSelect = ({
  productType,
  options = [],
  onOptionChange,
  values,
  setValue,
  setRequestFormValue,
  setSingleRequestFormValue,
  itemDetail,
  selectedValue,
  resetRequestFormValue,
  formInputs,
  testID,
}: RadioSelectType) => {
  const { t } = useTranslation();
  const { theme, typography } = useScreenOptionsHooks();
  const [selectedOption, setSelectedOption] = useState(
    selectedValue || options[0].key
  );
  const handleSelect = (option: any) => {
    setSelectedOption(option?.key);
    onOptionChange(option?.nestedInput);
    setValue("radioSelect", option?.key);
    resetFormForInputs(formInputs, resetRequestFormValue, setValue);
    if (Object?.keys?.(itemDetail)?.length > 0) {
      setSingleRequestFormValue(itemDetail.id, "radioSelect", option?.key);
    } else {
      setRequestFormValue("radioSelect", option?.key);
    }
  };
  useEffect(() => {
    setTimeout(() => {
      if (!values?.radioSelect) {
        setValue("radioSelect", options[0].key);
        setRequestFormValue("radioSelect", options[0].key);
        if (itemDetail?.id) {
          setSingleRequestFormValue(
            itemDetail.id,
            "radioSelect",
            options[0].key
          );
        } else {
          setRequestFormValue("radioSelect", options[0].key);
        }
      } else {
        handleSelect(options.find((item) => item.key === selectedValue));
      }
    }, 500);
  }, []);
  return (
    <RadioButtonContainer>
      {options.map((option, index) => (
        <>
          <ViewContainer
            key={index}
            selected={selectedOption === option.key}
            productType={productType}
            testID={testID + "." + option.key}
            data-testId={testID + "." + option.key}
          >
            <RadioButton
              label={t(option.label)}
              checked={selectedOption === option.key}
              onPress={() => handleSelect(option)}
              labelColor={
                selectedOption === option.key
                  ? theme["core-05"]
                  : theme["core-06"]
              }
              styles={
                selectedOption === option.key
                  ? typography["Body-M"]
                  : typography["Body-R"]
              }
            />
          </ViewContainer>
          {index < options.length - 1 && <Spacer size={SpaceType.Basic} />}
        </>
      ))}
    </RadioButtonContainer>
  );
};

const RadioButtonContainer = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const ViewContainer = styled.View<{
  selected: boolean;
  productType?: any;
}>`
  flex: 1;
  background-color: ${({ theme }: { theme: DefaultTheme }) => theme["core-02"]};
  border-color: ${({
    theme,
    selected,
    productType,
  }: {
    theme: DefaultTheme;
    selected: boolean;
    productType: any;
  }) =>
    selected
      ? productType === "diamond"
        ? theme["diam-01"]
        : productType === "gemstone"
        ? theme["gem-01"]
        : productType === "jewelry"
        ? theme["jewelry-01"]
        : theme["lab-01"]
      : theme["core-02"]};
  border-width: 1px;
  padding-top: ${SpaceType.Basic}px;
  padding-bottom: ${SpaceType.Basic}px;
  padding-left: ${SpaceType.Double}px;
  padding-right: ${SpaceType.Double}px;
  border-radius: ${SpaceType.Basic}px;
`;

export default RadioSelect;
